/**
 * Il gatto di Yuma: la sagoma del marchio di YumaOS (la stessa di `materiali/video-yumaos/sistema/grafica.mjs`) e i
 * suoi due colori. Lo disegnano la pagina di Yuma sul sito e la console, dallo stesso tracciato.
 */
export const GATTO_VIEWBOX = '8 5 48 54';

export const GATTO_SAGOMA =
  'M 11 6.5 L 25.6 16.2 C 29.8 15.3 34.2 15.3 38.4 16.2 L 53 6.5 L 51.8 27 C 55.4 34 54 45.2 46.5 51 C 42.4 54.9 37.4 57 32 57 C 26.6 57 21.6 54.9 17.5 51 C 10 45.2 8.6 34 12.2 27 Z M 19.8 34.5 a 3.7 3.7 0 1 0 7.4 0 a 3.7 3.7 0 1 0 -7.4 0 Z M 36.8 34.5 a 3.7 3.7 0 1 0 7.4 0 a 3.7 3.7 0 1 0 -7.4 0 Z M 29.2 43.4 L 34.8 43.4 L 32 47.2 Z';

/** Lo sfondo del gatto. */
export const VIOLA_NOTTE = '#201737';
/** Il gatto. */
export const LILLA = '#C1AEFF';
